import React from "react";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";

const Recommendations = ({ recommendation, setRecommendations }) => {

  const ROLE = localStorage.getItem("rol")

  function deleteRecomendation(id) {

    
    axios.delete(`recommendation/${id}`)
    .then(() => {
      toast.success("Recomendación Eliminada")
      setRecommendations(_old => {
        let aux = _old.filter(elm => parseInt(elm.id) !== parseInt(id))

        return [
          ...aux
        ]
      })
    })
    .catch(() => toast.error("No se pudo eliminar recomendación"))
  }

  return (
    <div className="testimonial">
      <div className="testimonial__wrapper">
        <div className="testimonial__author d-flex justify-content-between">
          <div>
            {recommendation.fromUser && recommendation.fromUser}
            <span>{moment(recommendation.creationDate).fromNow()}</span>
          </div>

          { ROLE === "admin" &&
            <div>
              <button
                className="delete-button"
                onClick={() => deleteRecomendation(recommendation.id)}
              />
            </div>

          }
        </div>

        <div className="testimonial__content">
          <strong>Recomienda Por:</strong>
          <p>{recommendation.description && recommendation.description}</p>
        </div>
      </div>
      
    </div>
  );
};

export default Recommendations;
